// extracted by mini-css-extract-plugin
module.exports = {"blogWrapper":"hl6Ib","blogCardWrapper":"z-GLC","blogCardText":"_3KopU","imgCard":"_1qKnZ"};